// Updated ConsultationType.js
import React from "react";
import styles from "./OnboardProject.module.scss";

const ConsultationType = ({
  project,
  selectedConsultationType,
  onSelect,
  onComplete,
  onBack,
  hasCenters,
  loading,
}) => {
  const consultationTypes = [
    {
      id: "medicalCentre",
      title: "Medical Centre",
      description: "Meet patients in person",
      icon: "🏥",
      disabled: !hasCenters,
    },
    {
      id: "online",
      title: "Online",
      description: "Meet patients online",
      icon: "💻",
      disabled: false,
    },
    {
      id: "both",
      title: "Both",
      description: "Meet patients online and in person",
      icon: "🔄",
      disabled: !hasCenters,
    },
  ];

  return (
    <div className={styles.stepContainer}>
      <div className={styles.stepHeader}>
        <h1>Choose consultation type</h1>
        <p>Select how you want to meet patients at {project?.clinicName}</p>
      </div>

      <div className={styles.consultationGrid}>
        {consultationTypes.map((type) => (
          <ConsultationCard
            key={type.id}
            type={type}
            onSelect={() => onSelect(type.id)}
            isSelected={selectedConsultationType === type.id}
          />
        ))}
      </div>

      <div className={styles.stepActions}>
        <button className={styles.backButton} onClick={onBack}>
          ← Back
        </button>
        {selectedConsultationType === "online" && (
          <button
            className={styles.nextButton}
            onClick={onComplete}
            disabled={!selectedConsultationType || loading}
          >
            {loading ? "Completing..." : "Complete Setup →"}
          </button>
        )}

        {selectedConsultationType && selectedConsultationType !== "online" && (
          <button
            className={styles.nextButton}
            onClick={() => onSelect(selectedConsultationType)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Continue →"}
          </button>
        )}
      </div>
    </div>
  );
};

const ConsultationCard = ({ type, onSelect, isSelected }) => {
  return (
    <div
      className={`${styles.consultationCard} ${isSelected ? styles.selected : ""} ${type.disabled ? styles.disabled : ""}`}
      onClick={!type.disabled ? onSelect : undefined}
    >
      <div className={styles.consultationIcon}>{type.icon}</div>
      <div className={styles.consultationContent}>
        <h3>{type.title}</h3>
        <p>{type.description}</p>
        {type.disabled && (
          <span className={styles.disabledBadge}>No centers available</span>
        )}
      </div>
      {!type.disabled && <div className={styles.consultationArrow}>→</div>}
    </div>
  );
};

export default ConsultationType;
